/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';

const Banner = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 40px;
	font-size: 16px;
	color: #fff;
	background: #${({type}) => type === 'error'
    ? 'ff5858'
    : '6df14c'
    };
	padding: 10px;
`;

const BannerClose = styled.span`
	position: absolute;
	top: 10px;
	right: 10px;
`;

class DismissableBanner extends React.Component {
    constructor() {
        super();

        this.state = {
            show: true,
        };
    }

    render() {
        const {show} = this.state;

        if (!show) {
            return null;
        }

        const {type = 'error', message = ''} = this.props;

        return (
            <Banner type={type} onClick={() => this.setState({show: false})}>
                {message}

                <BannerClose>X</BannerClose>
            </Banner>
        );
    }
}

export default DismissableBanner


// WEBPACK FOOTER //
// ./src/components/dismissable-banner/index.js